import {createSelector} from 'reselect';
import range from 'lodash/range';

import * as utils from './utils';

export const getLocation = createSelector(
    ({locationID}) => locationID,
    ({locations}) => locations,
    (id, locations) => locations[id] || null,
);

export const getFavorites = createSelector(
    ({locations}) => locations,
    locations => locations.favorites.map(id => locations[id]),
);

export const getHistory = createSelector(
    ({locations}) => locations,
    locations => locations.history.map(id => locations[id]),
);

export const getPOIs = createSelector(
    ({locationID}) => locationID,
    ({locations}) => locations,
    (id, locations) => [
        getLocation({locations, locationID: id}),
        ...getFavorites({locations}).filter(location => location.id !== id),
        ...getHistory({locations}).filter(location => location.id !== id),
    ],
);

export const getResolution = createSelector(
    ({resolution}) => resolution,
    ({resolutions}) => resolutions,
    utils.getByValue,
);

export const getStartHour = createSelector(
    ({startHour}) => startHour,
    ({startHours}) => startHours,
    utils.getByValue,
);

export const getMinimumResolution = createSelector(
    ({resolutions}) => resolutions,
    ([{value}]) => value,
);

const getSelectedIndices = createSelector(
    ({startHour}) => startHour,
    ({resolution}) => resolution,
    (startHour, resolution) => range(startHour, 24, resolution),
);

export const getAvailableIndices = createSelector(
    getSelectedIndices,
    getMinimumResolution,
    (idxs, minResolution) => idxs.filter(idx => idx % minResolution === 0),
);

export const getHeaders = createSelector(
    getAvailableIndices,
    ({indices}) => indices,
    (idxs, indices) => idxs.map(idx => indices[idx]),
);
